import { render } from "./HeadlineH2.vue?vue&type=template&id=a22bddd0"
import script from "./HeadlineH2.vue?vue&type=script&lang=js"
export * from "./HeadlineH2.vue?vue&type=script&lang=js"

import "./HeadlineH2.vue?vue&type=style&index=0&id=a22bddd0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__